import React, {  useContext } from 'react';
import Layout from '../../components/UI/Layout/Layout'
import CarList from '../../components/Entity/Cars/List/List';
import ListDealer from '../../components/Entity/Cars/ListDealer/ListDealer';
import { AppContext } from '../../providers/appProvider';

const Finance = () => {
    const { appState, app } = useContext(AppContext);
  
  return <Layout >  
      {
        appState.user?.role?.id === 20
          ? <ListDealer isArchive={false} isDelete={false} ></ListDealer> 
          : <CarList isArchive={false} isDelete={false} ></CarList>  
      } 
  </Layout>;
}

export default Finance;